import * as SecureStore from 'expo-secure-store';
import { Platform } from 'react-native';

const PENDING_TRIAL_PROMO_CODE_KEY = 'trialPromo.pendingCode';
const MAX_PROMO_CODE_LENGTH = 40;

function getWebStorage() {
  if (typeof localStorage === 'undefined') return null;
  if (typeof localStorage.getItem !== 'function') return null;
  if (typeof localStorage.setItem !== 'function') return null;
  if (typeof localStorage.removeItem !== 'function') return null;
  return localStorage;
}

export function normalizeTrialPromoCode(input: string | null | undefined): string | null {
  const code = input?.trim().toUpperCase().slice(0, MAX_PROMO_CODE_LENGTH) ?? '';
  return code.length > 0 ? code : null;
}

export async function setPendingTrialPromoCode(input: string | null | undefined): Promise<void> {
  const code = normalizeTrialPromoCode(input);

  if (!code) {
    await clearPendingTrialPromoCode();
    return;
  }

  if (Platform.OS === 'web') {
    const storage = getWebStorage();
    if (storage) storage.setItem(PENDING_TRIAL_PROMO_CODE_KEY, code);
    return;
  }

  await SecureStore.setItemAsync(PENDING_TRIAL_PROMO_CODE_KEY, code);
}

export async function getPendingTrialPromoCode(): Promise<string | null> {
  let raw: string | null = null;

  if (Platform.OS === 'web') {
    const storage = getWebStorage();
    raw = storage?.getItem(PENDING_TRIAL_PROMO_CODE_KEY) ?? null;
  } else {
    raw = await SecureStore.getItemAsync(PENDING_TRIAL_PROMO_CODE_KEY);
  }

  return normalizeTrialPromoCode(raw);
}

export async function clearPendingTrialPromoCode(): Promise<void> {
  if (Platform.OS === 'web') {
    const storage = getWebStorage();
    if (storage) storage.removeItem(PENDING_TRIAL_PROMO_CODE_KEY);
    return;
  }

  await SecureStore.deleteItemAsync(PENDING_TRIAL_PROMO_CODE_KEY);
}

export async function consumePendingTrialPromoCode(): Promise<string | null> {
  const code = await getPendingTrialPromoCode();
  await clearPendingTrialPromoCode();
  return code;
}
